import { useEffect, useEffectEvent } from 'react';

/** Calls `onEscape` when Escape is pressed while `active` is true (keyboard parity for click-outside dismiss). */
export function useEscapeKey(onEscape: () => void, active = true): void {
  const handleEscape = useEffectEvent(onEscape);
  useEffect(() => {
    if (!active) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') handleEscape();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [active]);
}
